import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BASE_URL, END_POINTS } from 'src/app/utility/APIConstants';
import { IContractorBill, IContractorPayment, IssueMaterial, ISubContractorWorkOrder, retentionPayment, TDSPayment } from '../master/models/subContractor.model';

@Injectable({ providedIn: 'root' })
export class SubContractorService {
  public selectedSubContWO: ISubContractorWorkOrder = null;
  public selectedContractorPayment: IContractorPayment = null;
  public selectedIssueMaterail: IssueMaterial = null;

  public selectedContractorBill: IContractorBill = null;

  public selectedTDSPayment: TDSPayment = null

  public selectedretentionPayment: retentionPayment = null

  constructor(private _http: HttpClient) { }

  public createSubContractorWorkOrder(payload): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.SubWORK_ORDER.CREATE, payload);
  }
  public updateSubContractorWorkOrder(id, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.SubWORK_ORDER.UPDATE(id), payload);
  }

  getWorkOrdersByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo`, { params });
  }

  public fetchSubContractorWorkOrdersById(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_BY_ID(id));
  }

  public approveSubContractorWorkOrder(id: number) {
    return this._http.put(BASE_URL + END_POINTS.SubWORK_ORDER.APPROVE(id), {});
  }

  public rejectSubContractorWorkOrder(id: number, payload: any) {
    return this._http.put(BASE_URL + END_POINTS.SubWORK_ORDER.REJECT(id), payload);
  }

  public fetchContractorSiteById(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_Contractor_Site_ID(id));
  }

  public fetchSUBWOByContractorId(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_SubWO_Contractor_ID(id));
  }

  public fetchSUBWOByContractorIdForIssue(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_Issue_SubWO_Contractor_ID(id));
  }

  public FETCH_WO_FOR_EDIT_ISSUE(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_WO_FOR_EDIT_ISSUE(id));
  }

  public fetchSUBWOByContractorIdForBill(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_SubWO_Contractor_ID_ForBill(id));
  }

  public printSubContractorWO(id: number) {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.PRINT(id), { responseType: 'blob' });
  }


  // ************** Issue MAterial ***********************//
  getIssueMAterialByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/mat-sc-wo`, { params });
  }

  public createIssueMAterial(payload): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.issue_Material.CREATE, payload);
  }

  public updateIssueMAterial(id, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.issue_Material.UPDATE(id), payload);
  }

  public fetchIssueMaterialById(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.issue_Material.FETCH_BY_ID(id));
  }

  public approveIssueMaterial(id: number) {
    return this._http.put(BASE_URL + END_POINTS.issue_Material.APPROVE(id), {});
  }

  public rejectIssueMaterial(id: number, payload: any) {
    return this._http.put(BASE_URL + END_POINTS.issue_Material.REJECT(id), payload);
  }

  public fetchSubWODetailsByID(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.SubWORK_ORDER.FETCH_SUBWO_DETAILS_BY_ID(id));
  }

  getproductDetailsByWO(woKey, boqKey): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/boqentry/boq/${woKey}/wo-details?boqKey=${boqKey}`);
  }

  public printIssueMaterial(id: number) {
    return this._http.get(BASE_URL + END_POINTS.issue_Material.PRINT(id), { responseType: 'blob' });
  }

  getMakesByProduct(productKey: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/product/${productKey}/makes`);
  }

  getAvailableStock(productKey: any, makeKey: any, warehouseKey: any): Observable<any> {
    const params = { productKey, makeKey, warehouseKey };
    return this._http.get<any>(`${environment.apiBase}/mat-sc-wo/stock`, { params });
  }


  //Sitewise consumptions 
  getContractorForSiteConsumption(siteKey: any) {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/status?contractor=true&forTrans=true&siteKey=${siteKey}`);
  }

  getWOForSiteConsumption(id: any) {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/wo-codes/${id}?forTrans=true`);
  }

  getWOForSiteEditConsumption(id: any) {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/wo-codes/${id}?forTrans=true&forEdit=true`);
  }

  getWOForContractorBillEntry(id: any) {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/wo-codes/${id}?forTrans=true&forBillEntry=true&forEdit=true`);
  }

  fetchProductForStockConsume(scWoKey, scWoDetKey) {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/details/${scWoKey}/${scWoDetKey}`);
  }

  getStockConsumptionByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/stock-consumption`, { params });
  }

  public createStockConsumption(payload): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.stock_consumption.CREATE, payload);
  }
  public updateStockConsumption(id, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.stock_consumption.UPDATE(id), payload);
  }

  public fetchStockConsumptionById(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.stock_consumption.FETCH_BY_ID(id));
  }

  public approveStockConsumption(id: number) {
    return this._http.put(BASE_URL + END_POINTS.stock_consumption.APPROVE(id), {});
  }

  public rejectStockConsumption(id: number, payload: any) {
    return this._http.put(BASE_URL + END_POINTS.stock_consumption.REJECT(id), payload);
  }

  //Contractor bill entry

  getContractorBillByPageCount(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-bill-entry`, { params });
  }

  public createContractorBill(payload): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.contractor_bill_entry.CREATE, payload);
  }
  public updateContractorBill(id, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.contractor_bill_entry.UPDATE(id), payload);
  }

  public fetchContractorBillById(id): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.contractor_bill_entry.FETCH_BY_ID(id));
  }

  public approveContractorBill(id: number) {
    return this._http.put(BASE_URL + END_POINTS.contractor_bill_entry.APPROVE(id), {});
  }

  public rejectContractorBill(id: number, payload: any) {
    return this._http.put(BASE_URL + END_POINTS.contractor_bill_entry.REJECT(id), payload);
  }

  public printContractorBill(id: number) {
    return this._http.get(BASE_URL + END_POINTS.contractor_bill_entry.PRINT(id), { responseType: 'blob' });
  }

  //contractor Payment
  getContractorPayment(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-advance-payment`, { params });
  }

  public createContractorpayment(payload: IContractorPayment): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT.CREATE, payload);
  }

  public updateContractorpayment(payload: IContractorPayment): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT.UPDATE(payload.conAdvPaymentKey), payload);
  }

  public ContractorPaymentGetById(id): Observable<any> {
    return this._http.get(`${environment.apiBase}/contractor-advance-payment/${id}`);
  }

  public approveCP(id: any): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT.APPROVE(id), {});
  }

  public rejectCP(id: any, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT.REJECT(id), payload);
  }

  getSubContractort(id: any): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/sub-contractor-wo/status?contractorKey=${id}&forBillEntry=true&forConPayment=true&forTrans=true&status=APPROVED`);
  }

  public getWoDetailsForAdvance(subConWoKey): Observable<any> {
    return this._http.get(`${environment.apiBase}/contractor-advance-payment/wo-details`, { params: { subConWoKey } });
  }

  public getAdvanceRequestStatus(subConWoKey): Observable<any> {
    return this._http.get(`${environment.apiBase}/contractor-advance-payment/status`, { params: { subConWoKey } });
  }

  public getAdvanceRequestDetails(subConWoKey): Observable<any> {
    return this._http.get(`${environment.apiBase}/contractor-advance-payment/details`, { params: { subConWoKey } });
  }

  public createContractorAdvancePaymentRequest(dto: any, file: File | null): Observable<any> {
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(dto)], { type: 'application/json' }));
    if (file) {
      formData.append('attachment', file);
    }
    return this._http.post(`${environment.apiBase}/contractor-advance-payment`, formData);
  }

  downloadPreviewFromS3(key: string) {
    return this._http.get(
      environment.apiBase + '/documents/downloadPreview?key=' + encodeURIComponent(key),
      { responseType: 'blob' }
    );
  }

  //Contractor Payment Workbench (waiting list + planning)

  // TODO(backend): replace with the real "all approved bills" endpoint once ready
  public fetchContractorBillEntries(): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-bill-entry/all`);
  }

  public fetchContractorPaymentWaitingList(): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT.FETCH);
  }

  public createContractorPaymentPlanning(payload: any): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT_PLANNING.CREATE, payload);
  }

  public updateContractorPaymentPlanning(id: number, payload: any): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT_PLANNING.UPDATE(id), payload);
  }

  public getAllContractorPaymentPlanning(): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.CONTRACTOR_PAYMENT_PLANNING.FETCH);
  }

  //TDS Payment

  getTDSPayment(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-tds-payment`, { params });
  }

  public createTDSPayment(payload: TDSPayment): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.TDS_PAYMENT.CREATE, payload);
  }

  public fetchTDSPaymentById(id): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-tds-payment/` + id);
  }

  public updateTDSPayment(id, payload): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/contractor-tds-payment/${id}`, payload)
  }


  public approveTDSPayment(id: any): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.TDS_PAYMENT.APPROVE(id), {});
  }

  public rejectTDSPayment(id: any, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.TDS_PAYMENT.REJECT(id), payload);
  }


  //Retention Payment

  getRetentionPayment(params = {}): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-retention-payment`, { params });
  }

  public createRetentionPayment(payload: TDSPayment): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.RETENTION_PAYMENT.CREATE, payload);
  }

  public fetchRetentionPaymentById(id): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/contractor-retention-payment/` + id);
  }

  public updateRetentionPayment(id, payload): Observable<any> {
    return this._http.put<any>(`${environment.apiBase}/contractor-retention-payment/${id}`, payload)
  }

  public approveRetentionPayment(id: any): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.RETENTION_PAYMENT.APPROVE(id), {});
  }

  public rejectRetentionPayment(id: any, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.RETENTION_PAYMENT.REJECT(id), payload);
  }

  //dpr

  createDpr(payload: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/dpr/create`, payload);
  }

  // getAllDpr(): Observable<any> {
  //   return this._http.get<any>(`${environment.apiBase}/dpr/list`);
  // }

 getAllDpr(payload: any): Observable<any> {
  return this._http.post<any>(`${environment.apiBase}/dpr/list`, payload);
}


  //dpr labour
  saveDprLabourDetails(payload: any): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/dpr/labour/save`, payload);
  }

  getDprLabourDetails(dprKey: number): Observable<any> {
    return this._http.get<any>(`${environment.apiBase}/dpr/labour/list/${dprKey}`);
  }

  saveDprEquipmentDetails(payload: any) {
  return this._http.post(
    `${environment.apiBase}/dpr/equipment/save`,
    payload,
    { responseType: 'text' }
  );
}

getDprById(dprKey: number): Observable<any> {
  return this._http.get<any>(`${environment.apiBase}/dpr/${dprKey}`);
}

updateDpr(dprKey: number, payload: any) {
  return this._http.put(
    `${environment.apiBase}/dpr/update/${dprKey}`,
    payload
  );
}

getProductBalanceQty(siteKey: number, productKey: number, makeKey: number): Observable<any> {
  return this._http.get(
    `${environment.apiBase}/stocktransaction/balance-qty`,
    { params: { siteKey, productKey, makeKey } }
  );
}


}